export function getQueryVariable(variable) {
	var query = window.location.search.substring(1)
	var vars = query.split('&')
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		if (decodeURIComponent(pair[0]) === variable) {
			return decodeURIComponent(pair[1])
		}
	}
	console.log(`Query variable '${variable}' not found`)
}

/**
 * Get all the URL parameters
 * @param  {String} search  window.location.search
 * @return {Object}         The URL parameters
 */
export const getAllQueryVariables = function (search = window.location.search, log = false) {
	const params = new URLSearchParams(search)
	let paramObj = {}
	for (var value of params.keys()) {
		paramObj[value] = params.get(value)
	}
	delete paramObj.refresh // It's for app refresh only
	if (log) {
		console.log('Query variables: ', paramObj)
	}
	return paramObj
}
